function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (priceTaxFeeAdjusterBase) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = "manualdiscount";
      _this.id = priceTaxFeeAdjuster.nextId;
      priceTaxFeeAdjuster.nextId++;
      _this.supplementalData = null;
      _this.priority = priceTaxFeeAdjuster.taxPriority - 50;
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "calculate",
      value: function calculate(productlist) {
        var _this2 = this;
        if (!Array.isArray(this.supplementalData) || !this.supplementalData.length) {
          return false;
        }

        // splice out all priceTaxFeeAdjusters containing objects that are no longer in the purchaselist - they may have gotten deleted since the last run
        this.supplementalData = this.supplementalData.filter(function (a) {
          return productlist.find(function (b) {
            return a.uuid === b.uuid;
          });
        });

        // splice out all priceTaxFeeAdjustments of the type that this function will create
        var _iterator = _createForOfIteratorHelper(productlist),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p = _step.value;
            p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments ? p.priceTaxFeeAdjustments.filter(function (a) {
              return a.name !== _this2.name;
            }) : [];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        this.supplementalData.forEach(function (a) {
          var p = productlist.find(function (b) {
            return a.uuid === b.uuid;
          });
          if (a.type === "percent") {
            var modifierDelta = p.priceTaxFeeAdjustments.reduce(function (total, a) {
              return a.name === "itemModifierPTF" ? total + a.price : total;
            }, 0);
            var discount = ((p.cashPrice ? p.intPrice : p.getPrice()) + modifierDelta) * -a.data;
          } else {
            var discount = -a.data;
          }
          p.priceTaxFeeAdjustments.push({
            name: _this2.name,
            id: _this2.id,
            priority: _this2.priority,
            price: +discount.toFixed(),
            tax: 0,
            fee: 0,
            extra: a
          });
        });
      }
    }, {
      key: "addManualdiscount",
      value: function addManualdiscount(item, type, data, source) {
        if (!item || typeof item.upc === "undefined") {
          console.error("First parameter must be a purchase item.", item, " was supplied.");
        }
        if (!type || !["percent", "cents"].includes(type)) {
          console.error('Second parameter must be "percent" or "cents". ', type, " was supplied.");
        }
        if (typeof data === "undefined" || isNaN(data)) {
          console.error('Third parameter must be supplied and numeric. "', type, '" was supplied.');
        }
        this.removeManualdiscount(item);
        this.supplementalData = this.supplementalData || [];
        if (data !== "0" && data !== 0) {
          this.supplementalData.push({
            uuid: item.uuid,
            type: type,
            data: data,
            source: source
          });
        }
      }
    }, {
      key: "removeManualdiscount",
      value: function removeManualdiscount(item) {
        var _this3 = this;
        // splice out the priceTaxFeeAdjustments of this item from the item and from the PTF calculator
        if (item.priceTaxFeeAdjustments && item.priceTaxFeeAdjustments.length) {
          item.priceTaxFeeAdjustments = item.priceTaxFeeAdjustments.filter(function (a) {
            return a.name !== _this3.name;
          });
        }
        if (Array.isArray(this.supplementalData)) {
          this.supplementalData = this.supplementalData.filter(function (a) {
            return a.uuid !== item.uuid;
          });
        }
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require("../base.js"));